import { MONERIS_VAULT } from './index';
import { Action } from '../action';

export class MonerisVaultInitAction implements Action {
	readonly type = MONERIS_VAULT.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class MonerisVaultDestroyAction implements Action {
	readonly type = MONERIS_VAULT.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class MonerisVaultShowIframeAction implements Action {
	readonly type = MONERIS_VAULT.SHOW_IFRAME;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class MonerisVaultHideIframeAction implements Action {
	readonly type = MONERIS_VAULT.HIDE_IFRAME;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class MonerisVaultClickRetryAction implements Action {
	readonly type = MONERIS_VAULT.CLICK_RETRY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
